//src/pages/AdminDashboard.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faFileAlt, faVideo, faRupeeSign, faWallet, faDonate, faQrcode, faCodeCommit, } from '@fortawesome/free-solid-svg-icons';
import '../styles/MyDashboard.css';
import '../styles/Tooltip.css';

const AdminDashboard = () => {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);

  const accessList = [
    '65ec578b1907326779a0cab0', '664ad6b3776439b03a972ae7', '664e0db94159f31c72c5e1a7',
  ];
  const hasAccess = accessList.includes(userId);

  return (
    <div className='bg-black'>
      <div className='min-h-[90vh]'>
        <div className="py-2 bg-black border-b border-blue-400">
          <div className='mx-4'>
              <h3 className='text-xl lg:text-2xl text-green-300'>Think5Whys Admin Dashboard</h3>
          </div>
        </div>
        {hasAccess ? (
            <div className="flex w-full justify-center">
              <div className="dashboard-container justify-center">
                <div className="group learning-group w-3/9">
                  <Link to="/userregistartion"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Users</Link>
                  <Link to="/entitylist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Entity</Link>
                  <Link to="/bookclub-list"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Book Club</Link>
                  <Link to="/booklist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Book Masters</Link>
                  <Link to="/giftvouchers"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Gift Vouchers</Link>
                  <Link to="/discountcoupons"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Discount Coupons</Link>
                  <Link to="/franchiseList"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Franchises</Link>
                  <Link to="/examslist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Exams</Link>
                  <Link to="/serieslist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Series</Link>
                  <Link to="/setlist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Sets</Link>
                  <Link to="/certificatelist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Certificates</Link>
                </div>
                <div className="group learning-group w-3/9">
                  <Link to="/assignmentlist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Assignments</Link>
                  <Link to="/templatelist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Templates</Link>
                  <Link to="/workbooklist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Workbooks</Link>
                  <Link to="/workshoplist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Workshops</Link>
                  <Link to="/moduleslist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />Modules</Link>
                  <Link to="/videolist"><FontAwesomeIcon icon={faVideo} style={{ marginRight: '10px' }} />Videos</Link>
                  <Link to="/payments"><FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '10px' }} />Payments</Link>
                  <Link to="/giftings"><FontAwesomeIcon icon={faUserCog} style={{ marginRight: '10px' }} />Giftings</Link>
                  <Link to="/visualbrieflist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />VisualBrief List</Link>
                  <Link to="/visigiftlist"><FontAwesomeIcon icon={faBook} style={{ marginRight: '10px' }} />VisiGift Lists</Link>
                </div>
                <div className="group learning-group w-3/9">
                  <Link to="/my-coding-team"><FontAwesomeIcon icon={faCodeCommit} style={{ marginRight: '10px' }} />My Coding Team</Link>
                  <Link to="/qrcodegenerator"><FontAwesomeIcon icon={faQrcode} style={{ marginRight: '10px' }} />My QR Generator</Link>
                  <Link to="/qrcodereader"><FontAwesomeIcon icon={faQrcode} style={{ marginRight: '10px' }} />My QR Scanner</Link>
                  <Link to="/mockpayment"><FontAwesomeIcon icon={faRupeeSign} style={{ marginRight: '10px' }} />Mock Payment</Link>
                  <Link to="/mockwalletrecharge"><FontAwesomeIcon icon={faWallet} style={{ marginRight: '10px' }} />Mock Wallet Recharge</Link>
                  <Link to="/mockdonation"><FontAwesomeIcon icon={faDonate} style={{ marginRight: '10px' }} />Mock Donation</Link>
                </div>
              </div>
            </div>
        ) : (
          <div className="text-lg mt-1 mx-8 text-white">
            <h3 style={{ color: 'white' }}>Access Denied</h3>
            <p>You do not have access to this dashboard.</p>
          </div>
        )}
      </div>
      <footer className="bg-black border-t border-blue-800 text-white py-4">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">
            © {new Date().getFullYear()} 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-200">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-200">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-200">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-200">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AdminDashboard;

